import { getLabelMessage } from '@gef-ui/localization/messages';

import isBirthNumber from 'app/forms/validations/isBirthNumber';
import isBusinessIn from 'app/forms/validations/isBusinessIn';
import isBusinessName from 'app/forms/validations/isBusinessName';
import isFirstName from 'app/forms/validations/isFirstName';
import isMunicipality from 'app/forms/validations/isMunicipality';
import isNumber from 'app/forms/validations/isNumber';
import isPolicyNo from 'app/forms/validations/isPolicyNo';
import isSurname from 'app/forms/validations/isSurname';
import isZipCode from 'app/forms/validations/isZipCode';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const MARKET_PLACE_FORM_NAME = 'marketPlace-filter';

const {
	taskType,
	taskSubTypeId,
	firstName,
	surname,
	businessName,
	businessIn,
	personIn,
	municipality,
	zipCode,
	policyNumber,
} = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	taskType,
	taskSubTypeId,
	firstName,
	surname,
	businessName,
	businessIn,
	personIn,
	municipality,
	zipCode,
	policyNumber,
};
export default () => ({
	[FIELDS.taskType]: {
		deepPath: [FIELDS.taskType],
		validations: [isSurname()],
	},
	[FIELDS.taskSubTypeId]: {
		deepPath: [FIELDS.taskSubTypeId],
		validations: [isFirstName()],
	},
	[FIELDS.firstName]: {
		deepPath: [FIELDS.firstName],
		validations: [isFirstName()],
	},
	[FIELDS.surname]: {
		deepPath: [FIELDS.surname],
		validations: [isSurname()],
	},
	[FIELDS.businessName]: {
		deepPath: [FIELDS.businessName],
		validations: [isBusinessName()],
	},
	[FIELDS.businessIn]: {
		deepPath: [FIELDS.businessIn],
		validations: [isBusinessIn()],
	},
	[FIELDS.personIn]: {
		deepPath: [FIELDS.personIn],
		validations: [isBirthNumber()],
	},
	[FIELDS.municipality]: {
		deepPath: [FIELDS.municipality],
		validations: [isMunicipality()],
	},
	[FIELDS.zipCode]: {
		deepPath: [FIELDS.zipCode],
		validations: [isZipCode()],
	},
	[FIELDS.policyNumber]: {
		deepPath: [FIELDS.policyNumber],
		validations: [isNumber({ customMessage: getLabelMessage('validation:allowedCharacters') }), isPolicyNo()],
	},
});
